import { ScrollText } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Collapsible } from '../ui';

interface Props {
  rules: string | null;
}

export function HouseRulesBlock({ rules }: Props) {
  const { t } = useTranslation();
  if (!rules) return null;
  return (
    <Collapsible
      title={t('stations.stay.houseRules.title')}
      icon={<ScrollText className="size-4" aria-hidden />}
    >
      <p className="text-fg whitespace-pre-wrap text-sm leading-relaxed">{rules}</p>
    </Collapsible>
  );
}
